import { Outlet } from "react-router";
import { FadingRule } from "@/components/layout/FadingRule";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { SiteHeader } from "@/components/layout/SiteHeader";

export function SiteLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-kt-cobalt text-kt-ink">
            {/* The design is drawn at 1280px. Capping the content there and centering it
                keeps the hero's heading and logo at their designed distance on wider
                screens instead of letting the grid stretch them apart, and keeps the
                nav, rules and footer aligned to the same edges. */}
            <div className="mx-auto flex w-full max-w-[1280px] flex-1 flex-col">
                <SiteHeader />
                <FadingRule className="text-white/22" />
                <main className="flex-1">
                    <Outlet />
                </main>
                <FadingRule className="text-white/16" />
                <SiteFooter />
            </div>
        </div>
    );
}
